import { render, staticRenderFns } from "./userMGT-password-edit.vue?vue&type=template&id=4bef3e69&scoped=true&"
import script from "./userMGT-password-edit.vue?vue&type=script&lang=js&"
export * from "./userMGT-password-edit.vue?vue&type=script&lang=js&"
import style0 from "./userMGT-password-edit.vue?vue&type=style&index=0&id=4bef3e69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bef3e69",
  null
  
)

export default component.exports